import { render, staticRenderFns } from "./ModalViewExpense.vue?vue&type=template&id=4b000105&"
import script from "./ModalViewExpense.vue?vue&type=script&lang=js&"
export * from "./ModalViewExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports